module.exports = __webpack_public_path__ + "static/media/goods1.35480d8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/goods1.png
// module id = 1224
// module chunks = 0